"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionHistoryErrorStatus = exports.Category = void 0;
var Category;
(function (Category) {
    Category["ALL"] = "all";
    Category["SPEEDALERT"] = "speedalert";
    Category["GEOFENCE"] = "geofence";
    Category["ANTITHEFTALARM"] = "antitheftalarm";
    Category["HONKFLASH"] = "honkflash";
    Category["REMOTELOCKUNLOCK"] = "remotelockunlock";
    Category["DIGITALKEY"] = "digitalkey";
    Category["TRANSACTION_HISTORY_ANTITHEFT_ALERT"] = "transactionHistoryAntiTheftAlert";
    Category["TRANSACTION_HISTORY_GEOFENCE"] = "transactionHistoryGeofence";
    Category["TRANSACTION_HISTORY_SPEED_ALERT"] = "transactionHistorySpeedAlert";
    Category["TRANSACTION_HISTORY_HONK_FLASH"] = "transactionHistoryHonkFlash";
    Category["TRANSACTION_HISTORY_LOCK_UNLOCK"] = "transactionHistoryLockUnlock";
    Category["TRANSACTION_HISTORY_DIGITAL_KEY"] = "transactionHistoryDigitalKey";
})(Category || (exports.Category = Category = {}));
var TransactionHistoryErrorStatus;
(function (TransactionHistoryErrorStatus) {
    TransactionHistoryErrorStatus[TransactionHistoryErrorStatus["UNKNOWN"] = 0] = "UNKNOWN";
    TransactionHistoryErrorStatus[TransactionHistoryErrorStatus["NO_CAPABILITIES"] = 1] = "NO_CAPABILITIES";
})(TransactionHistoryErrorStatus || (exports.TransactionHistoryErrorStatus = TransactionHistoryErrorStatus = {}));
//# sourceMappingURL=types.js.map